import { cx } from "shared/utils";

type Column<T> = {
  label: string;
  render: (item: T, idx: number) => React.ReactNode;
  className?: string;
};

type Props<T> = {
  data: T[];
  columns: Column<T>[];
  rowKey?: (item: T, idx: number) => React.Key;
};

export function SimpleTable<T>({ data, columns, rowKey }: Props<T>) {
  return (
    <table
      className="w-full mt-4 border-collapse"
      style={{ tableLayout: "fixed" }}
    >
      <thead>
        <tr>
          {columns.map((col, i) => (
            <th
              key={i}
              className={cx(
                `p-2 text-left ${col.className ?? ""}`,
                i === 0
                  ? "font-bold text-sm text-content-1000"
                  : "text-xs text-content-300"
              )}
            >
              {col.label}
            </th>
          ))}
        </tr>
      </thead>
      <tbody className="border-t border-alpha-100">
        {data.map((item, idx) => (
          <tr
            key={rowKey?.(item, idx) ?? idx}
            className="bg-background-800 h-16 text-sm text-content-500 font-medium"
          >
            {columns.map((col, i) => (
              <td key={i} className={`p-2 ${col.className ?? ""}`}>
                {col.render(item, idx)}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
